import PaymentsPaypalButtonModule from './payments-paypal-button.module'

export default PaymentsPaypalButtonModule
